interface CustomTooltipProps {
  active?: boolean;
  payload?: any[];
  label?: string;
}

export default function CustomTooltip({ active, payload, label }: CustomTooltipProps) {
  if (active && payload && payload.length) {
    const total = payload.reduce((sum: number, entry: any) => sum + entry.value, 0);

    return (
      <div className="bg-white/95 backdrop-blur-sm p-4 border border-gray-200 rounded-xl shadow-2xl shadow-gray-900/10">
        <div className="flex items-center gap-2 border-b border-gray-100 pb-3 mb-3">
          <div className="w-2 h-2 rounded-full bg-blue-500"></div>
          <p className="font-semibold text-gray-800 text-sm">{label}</p>
        </div>

        <div className="space-y-2">
          {payload
            .filter((entry: any) => entry.value > 0)
            .map((entry: any) => (
            <div key={entry.name} className="flex items-center justify-between gap-6">
              <div className="flex items-center gap-2.5">
                <div
                  className="w-3 h-3 rounded-full border border-white/50"
                  style={{ backgroundColor: entry.color }}
                />
                <span className="font-medium text-gray-700 text-sm">{entry.name}</span>
              </div>
              <span className="tabular-nums font-bold text-gray-900 text-sm">
                {entry.value.toLocaleString()}
              </span>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-100 mt-3 pt-3 flex justify-between font-bold text-gray-900">
          <span className="text-sm">Total:</span>
          <span className="tabular-nums text-sm">{total.toLocaleString()}</span>
        </div>
      </div>
    );
  }
  return null;
}